import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { Provider } from 'react-redux'
import { store } from './store/root'

const shadows = document.querySelectorAll('.tukios_shadow')
let containers = []

shadows.forEach(shadow => {
    if (shadow.shadowRoot) {
        containers.push(shadow.shadowRoot)
    }
})

containers.push(document)

containers.map(container => {
    const widgets = container.querySelectorAll('.tukios_widget')

    widgets.forEach(Div => {
        ReactDOM.render(
            <React.StrictMode>
                <Provider store={store}>
                    <App data={Div} />
                </Provider>
            </React.StrictMode>,
            Div
        )
    })
})

